/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MountingKpiValue } from '../../models/mounting-kpi-value';

export interface ToBeDismountedKpi$Params {
  workCenterId: number;
}

export function toBeDismountedKpi(http: HttpClient, rootUrl: string, params: ToBeDismountedKpi$Params, context?: HttpContext): Observable<StrictHttpResponse<MountingKpiValue>> {
  const rb = new RequestBuilder(rootUrl, toBeDismountedKpi.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MountingKpiValue>;
    })
  );
}

toBeDismountedKpi.PATH = '/api/v1/SecondaryMaterial/{workCenterId}/ToBeDismountedKpi';
